/* Cortazu mega menu: keyboard support for the desktop panels and the tabs in the mobile drawer.
   Custom file, not part of Hyper. Open/close, Escape, outside click and hover stay with Hyper
   (details[is=details-mega], menu-drawer, details[is=menu-drawer-details] in assets/header.js). */
(function () {
  'use strict';

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])'),
      function (el) { return el.offsetParent !== null || el.getClientRects().length > 0; }
    );
  }

  /* Desktop: Left/Right/Home/End move between top items, Down enters the open panel,
     Up/Down move through the panel links, Up from the first link returns to the top item. */
  function initNav(nav) {
    if (nav.dataset.czReady) return;
    nav.dataset.czReady = '1';
    var tops = Array.prototype.map.call(nav.querySelectorAll(':scope > ul > li'), function (li) {
      return li.querySelector(':scope > details > summary, :scope > a');
    }).filter(Boolean);

    function openAndEnter(summary) {
      var details = summary.parentElement;
      if (!details.open) details.open = true;
      var tries = 0;
      (function enter() {
        var panel = details.querySelector('.cz-mega__inner');
        var items = panel ? focusables(panel) : [];
        if (items.length) { items[0].focus(); return; }
        if (tries++ < 30) setTimeout(enter, 40); /* lazy panels: allow ~1.2s for the first load */
      })();
    }

    /* Load a panel's images on intent (hover or focus), so tiles are ready when it opens */
    function warm(e) {
      var li = e.target.closest && e.target.closest('.cz-mega');
      if (!li || li.dataset.czWarm) return;
      li.dataset.czWarm = '1';
      li.querySelectorAll('img[loading=lazy]').forEach(function (img) { img.loading = 'eager'; });
    }
    nav.addEventListener('mouseover', warm);
    nav.addEventListener('focusin', warm);

    nav.addEventListener('keydown', function (e) {
      var target = e.target;
      var topIndex = tops.indexOf(target);
      if (topIndex > -1) {
        var next = null;
        if (e.key === 'ArrowRight') next = tops[(topIndex + 1) % tops.length];
        else if (e.key === 'ArrowLeft') next = tops[(topIndex - 1 + tops.length) % tops.length];
        else if (e.key === 'Home') next = tops[0];
        else if (e.key === 'End') next = tops[tops.length - 1];
        if (next) {
          e.preventDefault();
          var d = target.parentElement;
          if (d && d.tagName === 'DETAILS' && d.open) d.open = false;
          next.focus();
          return;
        }
        if ((e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') && target.tagName === 'SUMMARY') {
          e.preventDefault();
          openAndEnter(target);
        }
        return;
      }
      var inner = target.closest && target.closest('.cz-mega__inner');
      if (!inner || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      var items = focusables(inner);
      var i = items.indexOf(target);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') {
        (items[i + 1] || items[0]).focus();
      } else if (i === 0) {
        inner.closest('details').querySelector(':scope > summary').focus();
      } else {
        items[i - 1].focus();
      }
    });
  }

  /* Mobile drawer tabs (Men / Women): WAI-ARIA tabs with automatic activation. */
  function initTabs(list) {
    if (list.dataset.czReady) return;
    list.dataset.czReady = '1';
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role=tab]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* Mobile slide-in panels: move focus to the back button on open and back to the row on close. */
  /* q25: full-screen mobile menu. Close via the overlay (Hyper's own close path), else the hamburger.
     If an ancestor (sticky/transformed header) shifts the fixed panel, pull it back to the viewport top. */
  function closeDrawer(drawer) {
    var overlay = drawer.querySelector('.fixed-overlay');
    var btn = Array.prototype.find.call(
      document.querySelectorAll('.menu-drawer-button[aria-controls="MenuDrawer"]'),
      function (b) { return b.offsetParent !== null; }
    );
    if (overlay) overlay.click();
    else if (btn) btn.click();
    if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, 50);
  }
  /* 3 Nov 2026 (audit F9 / X14): the hamburger states open/closed (aria-expanded), and focus returns to it when the
     drawer closes (Esc, overlay, close button). Hyper put it on the search icon next to it, or on <body>. Not when the
     close handed focus on to a field (drawer search -> header search) or to another open dialog (cart drawer). */
  function burgers() { return document.querySelectorAll('.menu-drawer-button[aria-controls="MenuDrawer"]'); }
  function setExpanded(open) {
    Array.prototype.forEach.call(burgers(), function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function returnFocus(drawer) {
    [80, 550].forEach(function (t) {
      setTimeout(function () {
        if (drawer.hasAttribute('open')) return;
        var b = Array.prototype.find.call(burgers(), function (x) { return x.getClientRects().length > 0; });
        var a = document.activeElement;
        if (!b || a === b) return;
        if (a && a !== document.body && !drawer.contains(a) &&
          (a.matches('input, textarea, select') || a.closest('[role="dialog"]:not(#MenuDrawer), dialog[open], cart-drawer[open]'))) return;
        b.focus({ preventScroll: true });
      }, t);
    });
  }
  function fitDrawer(drawer) {
    if (!window.matchMedia('(max-width: 1023px)').matches) return;
    drawer.style.top = '0px';
    var shift = drawer.getBoundingClientRect().top;
    if (Math.abs(shift) > 1) drawer.style.top = (-shift) + 'px';
  }


  /* 31 Oct 2026 (owner): search suggestions on focus (snippets/cz-search-chips.liquid), in the header search panel and the
     mobile drawer search. "Recent searches" = the last 5 searches this visitor submitted, in localStorage (czRecentSearches;
     every read/write in try/catch, so a blocked storage only hides the group). Recorded on: any search form submit,
     a chip tap, and a tap on a /search link inside the predictive search panel ("See all results", suggestions). */
  var RECENT_KEY = 'czRecentSearches';
  function getRecent() {
    var a = [];
    try { a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { a = []; }
    if (!Array.isArray(a)) return [];
    return a.filter(function (x) { return typeof x === 'string' && x.trim(); }).slice(0, 5);
  }
  function setRecent(a) {
    try {
      if (a.length) localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 5)));
      else localStorage.removeItem(RECENT_KEY);
    } catch (e) { /* storage blocked */ }
  }
  function addRecent(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim();
    if (!q || q.length > 80 || /^product_type:/i.test(q)) return;
    var low = q.toLowerCase();
    var a = getRecent().filter(function (x) { return x.toLowerCase() !== low; });
    a.unshift(q);
    setRecent(a);
  }
  function renderRecent(root) {
    var a = getRecent();
    (root || document).querySelectorAll('[data-cz-sq]').forEach(function (sq) {
      var grp = sq.querySelector('[data-cz-sq-recent]');
      var list = sq.querySelector('[data-cz-sq-list]');
      if (!grp || !list) return;
      var base = sq.getAttribute('data-search-url') || '/search?q=';
      list.textContent = '';
      a.forEach(function (q) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.href = base + encodeURIComponent(q);
        link.textContent = q;
        link.setAttribute('data-cz-sq-term', q);
        li.appendChild(link);
        list.appendChild(li);
      });
      grp.hidden = !a.length;
    });
  }
  var chipsReady = false;
  function initSearchChips() {
    if (chipsReady) return;
    chipsReady = true;
    renderRecent(document);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/search"]')) return;
      var i = f.querySelector('input[name="q"]:not([type="hidden"])');
      if (i) addRecent(i.value);
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var clear = t.closest('[data-cz-sq-clear]');
      if (clear) {
        e.preventDefault();
        setRecent([]);
        var box = clear.closest('predictive-search, .cz-drawer');
        renderRecent(document);
        var field = box && box.querySelector('input[type="search"]');
        if (field) field.focus({ preventScroll: true });
        return;
      }
      var chip = t.closest('[data-cz-sq-term]');
      if (chip) { addRecent(chip.getAttribute('data-cz-sq-term')); return; }
      var res = t.closest('predictive-search a[href*="/search?"]');
      if (res) {
        try { addRecent(new URL(res.href, location.origin).searchParams.get('q')); } catch (err) { /* ignore */ }
      }
    }, true);
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="search"]')) renderRecent(document);
    });
  }

  /* Drawer search: focus on the empty field shows the chips panel over the menu (input -> chips -> close in the Tab
     order). As soon as the visitor types, the text moves to the header's predictive search (full-screen search with
     live suggestions and product cards) and the drawer closes. Without the header search, Enter submits the form. */
  function initDrawerSearch(drawer) {
    var input = drawer.querySelector('[data-cz-drawer-q]');
    var panel = drawer.querySelector('[data-cz-drawer-sq]');
    var content = drawer.querySelector('.cz-drawer__content');
    if (!input || !panel || !content) return null;
    var form = input.form;
    var cancel = drawer.querySelector('[data-cz-sq-cancel]');
    var escHeld = false;
    function inSearch(el) { return panel.contains(el) || (form && form.contains(el)) || (cancel && cancel.contains(el)); }
    function show(on) {
      if (panel.hidden === !on) return;
      panel.hidden = !on;
      if (cancel) cancel.hidden = !on;
      content.classList.toggle('cz-drawer--sq', on);
      input.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { renderRecent(panel); panel.scrollTop = 0; }
    }
    function handoff() {
      var q = input.value;
      var sec = document.querySelector('.header-section');
      var hInput = sec && sec.querySelector('.header__search predictive-search input[type="search"]');
      var icon = sec && Array.prototype.find.call(sec.querySelectorAll('.cz-search-icon'), function (b) {
        return b.getClientRects().length > 0;
      });
      if (!hInput || !icon) return;
      show(false);
      input.value = '';
      var overlay = drawer.querySelector('.fixed-overlay');
      if (overlay) overlay.click();
      if (!sec.classList.contains('cz-search-open')) icon.click();
      hInput.value = q;
      try { hInput.focus({ preventScroll: true }); hInput.setSelectionRange(q.length, q.length); } catch (e) { /* ignore */ }
      hInput.dispatchEvent(new Event('input', { bubbles: true }));
      setTimeout(function () {
        if (sec.classList.contains('cz-search-open') && document.activeElement !== hInput) hInput.focus({ preventScroll: true });
      }, 450);
    }
    input.addEventListener('focus', function () { if (!input.value.trim()) show(true); });
    input.addEventListener('click', function () { if (!input.value.trim()) show(true); });
    input.addEventListener('input', function () {
      if (input.value.trim()) handoff();
      else show(true);
    });
    /* Escape (field, chips or Cancel) closes only the chips panel, not the whole drawer */
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden && inSearch(e.target)) {
        e.preventDefault(); e.stopImmediatePropagation(); escHeld = true;
        show(false); input.focus({ preventScroll: true });
      }
    }, true);
    drawer.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && escHeld) { e.stopImmediatePropagation(); escHeld = false; }
    }, true);
    if (cancel) cancel.addEventListener('click', function () {
      input.value = '';
      show(false);
      input.blur();
      drawer.focus({ preventScroll: true });
    });
    drawer.addEventListener('pointerdown', function (e) {
      if (panel.hidden || inSearch(e.target)) return;
      show(false);
    });
    drawer.addEventListener('focusin', function (e) {
      if (panel.hidden || inSearch(e.target) || e.target === drawer) return;
      show(false);
    });
    return { show: show };
  }

  /* Drawer top level: Women before Men when the visitor chose Women in the collection gender toggle
     (localStorage czGender = 'women', snippets/cz-gender-toggle.liquid). Otherwise the menu order. Desktop nav untouched. */
  function orderGender(drawer) {
    var ul = drawer.querySelector('.cz-drawer__more');
    if (!ul) return;
    var m = ul.querySelector(':scope > [data-cz-g-top="men"]');
    var w = ul.querySelector(':scope > [data-cz-g-top="women"]');
    if (!m || !w) return;
    if (!ul.czGOrig) ul.czGOrig = (m.compareDocumentPosition(w) & Node.DOCUMENT_POSITION_FOLLOWING) ? 'mw' : 'wm';
    var g = '';
    try { g = String(localStorage.getItem('czGender') || '').toLowerCase(); } catch (e) { g = ''; }
    var wFirst = g === 'women' || (g !== 'men' && ul.czGOrig === 'wm');
    var wIsFirst = !!(m.compareDocumentPosition(w) & Node.DOCUMENT_POSITION_PRECEDING);
    if (wFirst === wIsFirst) return;
    /* the one that should lead moves to just before the other (Men, Women adjacent in the menu = a swap) */
    if (wFirst) ul.insertBefore(w, m);
    else ul.insertBefore(m, w);
  }

  /* 1 Nov 2026 (owner): featured set tile on the drawer main level (snippets/cz-mega-menu.liquid .cz-drawer__feat):
     women's Ski set when czGender = 'women', else the men's. */
  function featGender(drawer) {
    var a = drawer.querySelector('[data-cz-feat]');
    if (!a) return;
    var g = '';
    try { g = String(localStorage.getItem('czGender') || '').toLowerCase(); } catch (e) { g = ''; }
    var h = a.getAttribute(g === 'women' ? 'data-href-women' : 'data-href-men');
    if (h) a.setAttribute('href', h);
  }

  /* 1 Nov 2026 (owner): keep account · country · language on one row (see .cz-drawer__foot--tight in cz-mega.css). */
  function fitFoot(drawer) {
    var f = drawer.querySelector('.cz-drawer__foot');
    if (!f || !f.offsetParent) return;
    f.classList.remove('cz-drawer__foot--tight');
    var kids = f.querySelectorAll('.cz-drawer__foot-acc, .country-switcher, .language-switcher');
    var top = null, wrap = false;
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].offsetParent) continue;
      var t = Math.round(kids[i].getBoundingClientRect().top);
      if (top === null) top = t; else if (Math.abs(t - top) > 4) wrap = true;
    }
    if (wrap) f.classList.add('cz-drawer__foot--tight');
  }

  function initSubpanels(drawer) {
    if (drawer.dataset.czReady) return;
    drawer.dataset.czReady = '1';
    /* 31 Oct 2026 (owner): the drawer is a dialog (role=dialog, aria-label "Menu"). On open, focus moves to the dialog
       itself (no on-screen keyboard), so the next Tab lands on the search field in the top bar, then the menu items,
       then the close button; Tab / Shift+Tab stay inside the dialog while it is open. */
    var wasOpen = false;
    setExpanded(drawer.hasAttribute('open'));
    orderGender(drawer);
    featGender(drawer);
    window.addEventListener('resize', function () { if (drawer.hasAttribute('open')) fitFoot(drawer); });
    var sq = initDrawerSearch(drawer);
    new MutationObserver(function () {
      var isOpen = drawer.hasAttribute('open');
      if (isOpen) fitDrawer(drawer);
      if (isOpen && !wasOpen) { orderGender(drawer); featGender(drawer); requestAnimationFrame(function () { fitFoot(drawer); }); }
      if (!isOpen && sq) sq.show(false);
      if (isOpen !== wasOpen) setExpanded(isOpen);
      if (!isOpen && wasOpen) returnFocus(drawer);
      if (isOpen && !wasOpen) setTimeout(function () {
        if (drawer.hasAttribute('open') && !drawer.contains(document.activeElement)) drawer.focus({ preventScroll: true });
      }, 60);
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['open', 'active'] });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) closeDrawer(drawer);
      if (e.key !== 'Tab' || !drawer.hasAttribute('open')) return;
      var items = focusables(drawer).filter(function (el) {
        return getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert], [hidden]');
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === drawer)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cz-drawer-close]')) { closeDrawer(drawer); return; }
      var summary = e.target.closest('.cz-drawer__sub > summary');
      if (summary) {
        var menus = drawer.querySelector('.cz-drawer__menus');
        if (menus) menus.scrollTop = 0;
        var back = summary.parentElement.querySelector('.cz-drawer__back');
        setTimeout(function () { if (back) back.focus({ preventScroll: true }); }, 450);
        return;
      }
      var backBtn = e.target.closest('.cz-drawer__back');
      if (backBtn) {
        var row = backBtn.closest('details').querySelector(':scope > summary');
        setTimeout(function () { if (row) row.focus({ preventScroll: true }); }, 50);
      }
    });
  }

  /* q26 (16 Oct): "Reviews | What customers say" shows the live Stamped score instead of the fixed line,
     e.g. "2,868 reviews on Stamped" (claims register C-05: live value, source named).
     Same public widget call as the reviews page (assets/cz-reviews.js); the PUBLIC key is the one in
     layout/theme.liquid (never the API secret). On any failure the original line stays. */
  var STAMPED_KEY = 'pubkey-DbpG9X8ybp813YH5NgnWZxtk5uTwz5';
  var STAMPED_SID = '72436';
  // Count only: the widget API's rating field reads 5.0 for the store (16 Oct), so no score here.
  var RATED = {
    en: '%c reviews on Stamped',
    nl: '%c reviews op Stamped',
    de: '%c Bewertungen auf Stamped'
  };
  var reviewsDone = false;
  function initReviewsLine() {
    if (reviewsDone) return;
    var subs = Array.prototype.filter.call(
      document.querySelectorAll('a[href$="/pages/reviews"] .cz-mega__sub'),
      function (el) { return !el.hasAttribute('data-cz-live'); }
    );
    if (!subs.length) return;
    reviewsDone = true;
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var tpl = RATED[lang] || RATED.en;
    function apply(d) {
      if (!d || !(d.c > 0)) return;
      var nf1, nf0;
      try {
        nf1 = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        nf0 = new Intl.NumberFormat(lang);
      } catch (e) {
        nf1 = { format: function (n) { return n.toFixed(1); } };
        nf0 = { format: String };
      }
      var text = tpl.replace('%c', nf0.format(d.c));
      subs.forEach(function (el) { el.textContent = text; el.setAttribute('data-cz-live', ''); });
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('czStampedCount') || 'null'); } catch (e) {}
    if (cached && cached.t > Date.now() - 6 * 3600 * 1000) { apply(cached); return; }
    var url = 'https://stamped.io/api/widget/reviews?apiKey=' + encodeURIComponent(STAMPED_KEY) +
      '&sId=' + STAMPED_SID + '&storeUrl=' + encodeURIComponent(location.hostname) + '&take=1&page=1';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        var d = { r: parseFloat(j.ratingAll != null ? j.ratingAll : j.rating), c: parseInt(j.totalAll != null ? j.totalAll : j.total, 10), t: Date.now() };
        try { sessionStorage.setItem('czStampedCount', JSON.stringify(d)); } catch (e) {}
        apply(d);
      })
      .catch(function () { reviewsDone = false; });
  }
  function scheduleReviewsLine() {
    // Off the critical path: after load, when the browser is idle.
    var run = function () { initReviewsLine(); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 2500);
  }

  /* 31 Oct 2026 (owner, option B): mobile drawer "Sets" level (snippets/cz-mega-settiles.liquid, style 'mgrid').
     Men | Women = radio group (arrow keys move + select); default localStorage czGender, else Men. The switch
     swaps every tile's href (data-href-men / data-href-women). Photos load only when the Sets level opens.
     31 Oct 2026 (owner: switch did nothing on iPhone Safari): taps are handled by ONE delegated listener on the document
     (capture phase), found via closest() at tap time, so it works whatever happens to the drawer markup and no other
     handler can swallow it. A touchend fallback (finger moved < 10px) selects too, for the case where iOS does not send
     the click after a tap; selecting is idempotent, so touchend + click on the same tap is harmless. Plain ES5. */
  function msetsFromStore() {
    var g = '';
    try { g = String(localStorage.getItem('czGender') || '').toLowerCase(); } catch (e) { g = ''; }
    return g === 'women' ? 'women' : 'men';
  }
  function msetsSelect(root, g, focus) {
    if (g !== 'men' && g !== 'women') return;
    var opts = root.querySelectorAll('[data-cz-msets-g]');
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].getAttribute('data-cz-msets-g') === g;
      opts[i].setAttribute('aria-checked', on ? 'true' : 'false');
      opts[i].tabIndex = on ? 0 : -1;
      if (on && focus) opts[i].focus();
    }
    var tiles = root.querySelectorAll('[data-href-men]');
    for (var j = 0; j < tiles.length; j++) {
      var h = tiles[j].getAttribute('data-href-' + g);
      if (h) tiles[j].setAttribute('href', h);
    }
    root.setAttribute('data-g', g);
  }
  function msetsLoad(root) {
    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); });
        if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      })(imgs[i]);
    }
  }
  function msetsOpt(t) {
    if (t && t.nodeType !== 1) t = t.parentElement;
    return t && t.closest ? t.closest('[data-cz-msets-g]') : null;
  }
  function msetsPick(opt, focus) {
    var root = opt.closest('[data-cz-msets]');
    if (!root) return;
    root.setAttribute('data-touched', '');
    msetsSelect(root, opt.getAttribute('data-cz-msets-g'), focus);
  }
  var msetsBound = false;
  function bindMsets() {
    if (msetsBound) return;
    msetsBound = true;
    document.addEventListener('click', function (e) {
      var o = msetsOpt(e.target);
      if (!o) return;
      e.preventDefault();
      msetsPick(o, false);
    }, true);
    var tStart = null;
    document.addEventListener('touchstart', function (e) {
      var o = msetsOpt(e.target);
      var t = e.touches && e.touches[0];
      tStart = o && t ? { o: o, x: t.clientX, y: t.clientY } : null;
    }, { capture: true, passive: true });
    document.addEventListener('touchend', function (e) {
      var s = tStart;
      tStart = null;
      var t = e.changedTouches && e.changedTouches[0];
      if (!s || !t || Math.abs(t.clientX - s.x) > 10 || Math.abs(t.clientY - s.y) > 10) return;
      if (msetsOpt(e.target) === s.o) msetsPick(s.o, false);
    }, { capture: true, passive: true });
    document.addEventListener('keydown', function (e) {
      var o = msetsOpt(e.target);
      if (!o) return;
      var k = e.key, d = 0;
      if (k === 'ArrowRight' || k === 'ArrowDown') d = 1;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') d = -1;
      else if (k === ' ' || k === 'Enter') { e.preventDefault(); msetsPick(o, false); return; }
      if (!d) return;
      var root = o.closest('[data-cz-msets]');
      if (!root) return;
      var opts = root.querySelectorAll('[data-cz-msets-g]');
      var i = Array.prototype.indexOf.call(opts, o);
      e.preventDefault();
      msetsPick(opts[(i + d + opts.length) % opts.length], true);
    }, true);
  }
  function initMsets(root) {
    bindMsets();
    if (root.getAttribute('data-cz-ready')) return;
    root.setAttribute('data-cz-ready', '1');
    msetsSelect(root, msetsFromStore(), false);
    var det = root.closest('details');
    if (!det) { msetsLoad(root); return; }
    function onOpen() {
      if (!det.hasAttribute('open')) return;
      if (!root.hasAttribute('data-touched')) msetsSelect(root, msetsFromStore(), false);
      msetsLoad(root);
    }
    det.addEventListener('toggle', onOpen);
    var sum = det.querySelector('summary');
    if (sum) sum.addEventListener('click', function () { setTimeout(onOpen, 0); msetsLoad(root); });
    onOpen();
  }

  /* 1 Nov 2026 (speed round 2): lazy mega menu panels (snippets/cz-mega-menu.liquid, sections/header.liquid).
     Pages render the top level only; the desktop panels (.cz-mega__inner[data-cz-mega-slot]) and the drawer sub levels
     (.cz-drawer__subscroll[data-cz-drw-slot]) are filled from the header section rendered in full on the alternate view
     ?view=cz-mega (Section Rendering API, URL in nav[data-cz-mega-lazy], locale prefix included). Loaded on the first
     hover / focus in the desktop nav, the first hamburger tap, or when the browser is idle after load; cached in
     sessionStorage per menu signature (data-cz-mega-sig: locale, theme asset versions, menu), so later pages fill the
     slots before the visitor can open them. Same markup as the server-rendered menu, so nothing changes once open.
     Storage blocked = one fetch per page (try/catch everywhere). */
  var LZ_PREFIX = 'czMegaP:';
  var lzState = 0; /* 0 idle, 1 loading, 2 done */
  function lzNav() { return document.querySelector('[data-cz-mega-lazy]'); }
  function lzKey(nav) { return LZ_PREFIX + (nav.getAttribute('data-cz-mega-sig') || ''); }
  function lzPending() { return document.querySelector('[data-cz-mega-slot], [data-cz-drw-slot]'); }
  function lzApply(data) {
    if (!data || !data.d || !data.m) return false;
    var any = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cz-mega-slot]'), function (el) {
      var h = data.d[el.getAttribute('data-cz-mega-slot')];
      if (typeof h !== 'string') return;
      el.innerHTML = h;
      el.removeAttribute('data-cz-mega-slot');
      var li = el.closest('.cz-mega');
      if (li) delete li.dataset.czWarm;
      any = true;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cz-drw-slot]'), function (el) {
      var h = data.m[el.getAttribute('data-cz-drw-slot')];
      if (typeof h !== 'string') return;
      el.innerHTML = h;
      el.removeAttribute('data-cz-drw-slot');
      any = true;
    });
    if (any) {
      lzState = 2;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cz-msets]'), initMsets);
      markActive(true);
      if (!reviewsDone) scheduleReviewsLine();
      try { document.dispatchEvent(new CustomEvent('cz:mega-loaded')); } catch (e) { /* old browser */ }
    }
    return any;
  }
  function lzExtract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var d = {}, m = {}, n = 0;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cz-mega-k]'), function (el) { d[el.getAttribute('data-cz-mega-k')] = el.innerHTML; n++; });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cz-drw-k]'), function (el) { m[el.getAttribute('data-cz-drw-k')] = el.innerHTML; n++; });
    return n ? { d: d, m: m } : null;
  }
  function lzLoad() {
    var nav = lzNav();
    if (!nav || lzState) return;
    if (!lzPending()) { lzState = 2; return; }
    lzState = 1;
    fetch(nav.getAttribute('data-cz-mega-lazy'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var data = html ? lzExtract(html) : null;
        if (!data || !lzApply(data)) { lzState = 0; return; }
        try {
          for (var i = sessionStorage.length - 1; i >= 0; i--) {
            var k = sessionStorage.key(i);
            if (k && k.indexOf(LZ_PREFIX) === 0) sessionStorage.removeItem(k);
          }
          sessionStorage.setItem(lzKey(nav), JSON.stringify(data));
        } catch (e) { /* storage blocked or full */ }
      })
      .catch(function () { lzState = 0; });
  }
  function initLazy() {
    var nav = lzNav();
    if (!nav || nav.dataset.czLz) return;
    nav.dataset.czLz = '1';
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(lzKey(nav)) || 'null'); } catch (e) { cached = null; }
    if (cached && lzApply(cached)) return;
    var go = function () { lzLoad(); };
    nav.addEventListener('pointerover', go, { once: true });
    nav.addEventListener('focusin', go, { once: true });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.menu-drawer-button, [aria-controls="MenuDrawer"]')) lzLoad();
    }, true);
    document.addEventListener('touchstart', function (e) {
      if (e.target && e.target.closest && e.target.closest('.menu-drawer-button, [aria-controls="MenuDrawer"]')) lzLoad();
    }, { capture: true, passive: true });
    var idle = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 });
      else setTimeout(go, 1500);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  /* Active top item (underline, .cz-active), same rule as sections/cortazu-header-enhancements.liquid: exact path +
     query first, else path. That script runs before the panels exist, so with lazy panels this one marks the item:
     from the raw menu URLs (li[data-cz-hrefs]) right away, then again from the real panel links once they are in. */
  function markActive(fromLinks) {
    var strip = function (p) { return p.replace(/^\/(nl|de|en)(?=\/|$)/, '') || '/'; };
    var here = strip(location.pathname);
    if (here === '/') return;
    var tops = Array.prototype.slice.call(document.querySelectorAll('.header-section .header__menu > ul > li'));
    if (!tops.length) return;
    var hrefs = function (li) {
      var a = Array.prototype.map.call(li.querySelectorAll('a[href]'), function (x) { return x.getAttribute('href'); });
      if (!a.length && li.getAttribute('data-cz-hrefs')) a = li.getAttribute('data-cz-hrefs').split(/\s+/);
      return a;
    };
    var match = function (useQuery) {
      for (var i = 0; i < tops.length; i++) {
        var list = hrefs(tops[i]);
        for (var j = 0; j < list.length; j++) {
          if (!list[j]) continue;
          var u; try { u = new URL(list[j], location.origin); } catch (err) { continue; }
          if (u.origin !== location.origin) continue;
          if (strip(u.pathname) + (useQuery ? u.search : '') === here + (useQuery ? location.search : '')) return tops[i];
        }
      }
      return null;
    };
    var hit = (location.search && match(true)) || match(false);
    if (!hit) return;
    if (!fromLinks && document.querySelector('.header-section .header__menu > ul > li.cz-active')) return;
    tops.forEach(function (li) { li.classList.toggle('cz-active', li === hit); });
  }

  function init() {
    initLazy();
    if (lzNav() && lzPending()) markActive(false);
    scheduleReviewsLine();
    initSearchChips();
    document.querySelectorAll('[data-cz-mega-nav]').forEach(initNav);
    document.querySelectorAll('[data-cz-tabs]').forEach(initTabs);
    document.querySelectorAll('menu-drawer.cz-drawer').forEach(initSubpanels);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cz-msets]'), initMsets);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 2 Nov 2026 (owner: "geflits in de header op desktop"). Hyper's DetailsMega slides a panel down on open and up on
   close (0.5 s each). Moving from one top item to the next ran both at once; the panels differ in height, so the page
   showed through between them. Now: while another panel is open, the new panel appears at once and the old one hides
   at once; the first open and the final close keep Hyper's slide. Desktop panels only (details[data-cz-mega]). */
(function () {
  'use strict';
  function others(d) {
    return Array.prototype.some.call(document.querySelectorAll('details[data-cz-mega]'), function (x) { return x !== d && x.open; });
  }
  function instant(d, show) {
    var el = d.contentElement && d.contentElement.firstElementChild;
    if (!el || !window.FoxTheme || !FoxTheme.Motion) return Promise.resolve();
    return FoxTheme.Motion.animate(el, show ? { visibility: 'visible', transform: 'translateY(0)' } : { visibility: 'hidden', transform: 'translateY(-100%)' }, { duration: 0 }).finished;
  }
  function patch() {
    document.querySelectorAll('details[data-cz-mega]').forEach(function (d) {
      if (d.__czSwitch || typeof d.showWithTransition !== 'function') return;
      d.__czSwitch = true;
      var show = d.showWithTransition, hide = d.hideWithTransition;
      d.showWithTransition = function () { return others(d) ? instant(d, true) : show.call(d); };
      d.hideWithTransition = function () { return others(d) ? instant(d, false) : hide.call(d); };
    });
  }
  function init() {
    if (customElements.get('details-mega')) patch();
    else if (customElements.whenDefined) customElements.whenDefined('details-mega').then(function () { setTimeout(patch, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 3 Nov 2026 (go-live bug, owner): after closing the mobile menu with its own close button (and sometimes after the
   quick view or size sheet), Hyper left the class "modal-showing" on <body>, which keeps overflow hidden: the page
   could no longer be scrolled on phones. Safety net: whenever <body> carries modal-show / modal-showing, check shortly
   after whether any overlay is still open (element with [open] other than <details>, visible); if none, remove them. */
(function () {
  if (window.czScrollUnlock) return;
  window.czScrollUnlock = true;
  var CLS = ['modal-show', 'modal-showing'];
  function anyOpen() {
    return Array.prototype.some.call(document.querySelectorAll('[open]:not(details), .modal.is-open, dialog[open]'), function (el) {
      if (el.tagName === 'DETAILS') return false;
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden') return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }
  var t1, t2;
  function check() { if (!anyOpen()) CLS.forEach(function (c) { document.body.classList.remove(c); }); }
  function schedule() {
    if (!CLS.some(function (c) { return document.body.classList.contains(c); })) return;
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(check, 700); t2 = setTimeout(check, 1600);
  }
  function start() {
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', schedule, true);
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') schedule(); });
    schedule();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
